module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-479-min.e80a19ca.jpg";